/**
 * Axios instance for admin API calls.
 *
 * Reads the Cognito access token from the module-level store so it can be
 * attached to every request without needing React context in the interceptor.
 */

import axios from 'axios'
import { API_BASE_URL } from './client'

let adminToken: string | null = null

export function setAdminToken(token: string | null): void {
  adminToken = token
}

export const adminApiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
})

adminApiClient.interceptors.request.use(
  (config) => {
    if (adminToken) {
      config.headers['X-Admin-Authorization'] = `Bearer ${adminToken}`
    }
    return config
  },
  (error) => Promise.reject(error),
)
